import Client from '../../services/client';
import { getUsersRoute } from './routes';

export const getUsers = () => Client.get(getUsersRoute());

export const updateUsers = (data) => Client.put(getUsersRoute(), data);
